import {
  formatDateToDayMonth,
  formatDateToShortMonthYear,
  formatCurrency,
  formatPercentage,
} from "@utils/formatNumber"

//-------------------------------------------------------------------
const getColumnDefinitionFromRange = (range, t) => {
  switch (range) {
    case "daily":
      return {
        headerCols: [t("col_DATE"), t("col_PRICE"), t("col_CHANGE")],
        colSize: 3,
      }

    case "monthly":
      return {
        headerCols: [t("col_DATE"), t("col_AVG_PRICE"), t("col_CHANGE")],
        colSize: 3,
      }

    case "yearly":
      return {
        headerCols: [t("col_DATE"), t("col_AVG_PRICE"), t("col_CHANGE")],
        colSize: 3,
      }
  }
}

//-------------------------------------------------------------------
const getPriceRows = (visiblePriceList, range, currency, symbol, locale) => {
  switch (range) {
    case "daily":
      return visiblePriceList.map((price, idx, list) => {
        let diff = 0.0
        if (idx > 0) {
          const prevPrice = list[idx - 1][currency]
          diff = (price[currency] - prevPrice) / prevPrice
        }
        const tickDate = new Date(price.dt)
        return [
          formatDateToDayMonth(tickDate, locale),
          formatCurrency(price[currency], locale, currency),
          (diff > 0 ? "+" : "") + formatPercentage(diff, locale, 2),
        ]
      })

    case "monthly":
      return visiblePriceList.map((price, idx, list) => {
        let diff = 0.0
        if (idx > 0) {
          const prevPrice = list[idx - 1][currency]
          diff = (price[currency] - prevPrice) / prevPrice
        }

        return [
          formatDateToShortMonthYear(price.dt, locale),
          formatCurrency(price[currency], locale, currency),
          (diff > 0 ? "+" : "") + formatPercentage(diff, locale, 2),
        ]
      })

    case "yearly":
      return visiblePriceList.map((price, idx, list) => {
        let diff = 0.0
        if (idx > 0) {
          const prevPrice = list[idx - 1][currency]
          diff = (price[currency] - prevPrice) / prevPrice
        }

        return [
          price.date,
          formatCurrency(price[currency], locale, currency),
          (diff > 0 ? "+" : "") + formatPercentage(diff, locale, 2),
        ]
      })
  }
}

//-------------------------------------------------------------------
export const generateTableData = (
  range,
  currency,
  prices,
  visibleRows,
  t,
  locale
) => {
  const newTableData = {
    rows: [],
    ...getColumnDefinitionFromRange(range, t),
  }
  const { symbol } = prices.availableCurrencies.find(ac => ac.id === currency)

  newTableData.rows = getPriceRows(
    prices.priceList[range].slice(-1 * visibleRows),
    range,
    currency,
    symbol,
    locale
  ).reverse()
  return newTableData
}
